export interface PurchaseOrderLineCheckStatus {
  id: string;
  status: string;
  deliveryNoteNo: string;
  orderType: string;
}
